import _ from "lodash";
import { SYSTEM_PROPERTIES_URL} from "../../../constants/api-urls";
import httpService from "../../../shared/http-service/http.service";

export interface SystemProperty {
    id:    number;
    code:  string;
    value: string;
}

class SystemPropertyService {
    private properties: SystemProperty[] = [];

    public async init(): Promise<void> {
        this.properties = await httpService.get<SystemProperty[]>(SYSTEM_PROPERTIES_URL);
    }

    public getProperty(code: string): string | null {
        const descriptor = this.getPropertyDescriptor(code);
        if(!descriptor) {
            return null;
        }

        return descriptor.value;
    }

    public getPropertyOrError(code: string): string {
        const descriptor = this.getPropertyDescriptor(code);
        if (descriptor === null) {
            throw new Error(`Cannot find system property: ${code}`);
        }
        return descriptor.value;
    }

    public getPropertyDescriptor(code: string): SystemProperty | null {
        const property: SystemProperty | undefined = this.properties.find(prop => prop.code === code);
        if(!property) {
            return null;
        }

        return property;
    }

    public getPropertyDescriptors(): SystemProperty[] {
        return _.cloneDeep(this.properties);
    }
}

export default new SystemPropertyService();
export const serviceType = SystemPropertyService;